// extracted by mini-css-extract-plugin
export default {"description":"styles_description__1K5hA","right":"styles_right__0zZmu","marginAuto":"styles_marginAuto__AjH81","textRight":"styles_textRight__Tjp75"};